import HttpBackend from 'i18next-http-backend';
import { configureI18n } from './i18n-config';
import { PopConfiguration } from '../configuration';
import i18next from 'i18next';

class I18nService {
  isI18nSetupComplete = false;
  private setupPromise: Promise<void> | null = null;
  private readonly i18nSetupCallbacks: Array<() => void> = [];
  private readonly loadedLanguages = new Set();
  private readonly loadingLanguages = new Map();

  isI18nSetup() {
    return this.isI18nSetupComplete;
  }

  async setupi18n() {
    if (this.setupPromise) {
      return this.setupPromise;
    }

    this.setupPromise = (async () => {
      await configureI18n(async (languagePath, i18nOptions) => {
        const popConfiguration = new PopConfiguration();
        i18nOptions.backend.loadPath = `${popConfiguration.getAssetBaseUrl()}/${languagePath}`;
        await i18next.use(HttpBackend).init(i18nOptions);
      });
      this.isI18nSetupComplete = true;
      this.i18nSetupCallbacks.forEach((callback) => callback());
    })();

    return this.setupPromise;
  }

  /**
   * Calls the callback when the language is loaded.
   * Does not call the callback if the language is already loaded.
   */
  loadi18nForLanguage(lng, callback): void {
    if (!this.loadedLanguages.has(lng)) {
      const loadResourceBundle = () => {
        if (!this.loadingLanguages.has(lng)) {
          this.loadingLanguages.set(lng, [callback]);
          // We use changeLanguage instead of loadLanguages as it looks like
          // there is a bug in i18next where loadLanguages calls the callback
          // before the languages are loaded
          i18next.changeLanguage(lng, (err: unknown) => {
            if (err) {
              console.error('Error loading language: ', err);
            }
            if (!this.loadedLanguages.has(lng)) {
              this.loadedLanguages.add(lng);
            }
            const loadingLanguagesCallbacks = this.loadingLanguages.get(lng);
            if (loadingLanguagesCallbacks) {
              loadingLanguagesCallbacks.forEach((cb) => cb());
            }
          });
        } else {
          const loadingLanguagesCallbacks = this.loadingLanguages.get(lng);
          loadingLanguagesCallbacks.push(callback);
        }
      };

      if (this.isI18nSetup()) {
        loadResourceBundle();
      } else {
        this.i18nSetupCallbacks.push(loadResourceBundle);
      }
    }
  }

  isI18nLoadedForLanguage(lng) {
    return this.loadedLanguages.has(lng);
  }

  getFixedT(lng, ns, keyPrefix) {
    return i18next.getFixedT(lng, ns, keyPrefix);
  }
}

export const i18nService = new I18nService();
